import React, { memo } from 'react';
import { BlockUI, BlockUIProps } from 'primereact/blockui';
import { useTranslation } from 'react-i18next';
import { signify } from 'react-signify';

const loadingSignal = signify(0);
const DELAY_TIME = 500;

export const loadingScreen = {
  show: () => loadingSignal.set((pre) => (pre.value += 1)),
  hide: () =>
    loadingSignal.set((pre) => {
      pre.value = pre.value > 0 ? pre.value - 1 : pre.value;
    }),
  hardHide: () => loadingSignal.reset(),
  hideDelay: () => new Promise((resolve) => setTimeout(resolve, DELAY_TIME)).then(() => loadingScreen.hide()),
  hardHideDelay: () => new Promise((resolve) => setTimeout(resolve, DELAY_TIME)).then(() => loadingSignal.reset()),
};

const style1 = {
  display: 'flex',
  backgroundColor: 'white',
  height: 'auto',
  width: '573px',
  flexDirection: 'column',
  borderRadius: '2.5px',
  border: '1px solid #CCCED5',
  background: '#FFF',
  boxShadow: '1px 1px 2px 0px rgba(16, 24, 40, 0.15), 0px 1px 3px 0px rgba(16, 24, 40, 0.30)',
} as React.CSSProperties;
const style2 = {
  padding: '20px',
  fontSize: '16px',
} as React.CSSProperties;

const styleRootLoading: React.CSSProperties = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const styleInfinityLoading: React.CSSProperties = {
  height: '8px',
  background: 'repeating-linear-gradient(45deg, #4c4fe1 0 10px, #6774ed 10px 20px) left/200% 100%',
  animation: 'i3 5s infinite linear',
  borderRadius: '3px',
};

const keyframesStyle = `
  @keyframes i3 {
    100% { background-position: right; }
  }
`;

const LoadingTemplate: React.FC = memo(() => {
  const { t } = useTranslation();
  return (
    <>
      <style>{keyframesStyle}</style>
      <div style={style1}>
        <div style={style2}>{t('loading')}...</div>
        <div style={{ ...styleRootLoading, height: '48px' }}>
          <div style={{ ...styleInfinityLoading, width: 'calc(100% - 40px)' }} />
        </div>
      </div>
    </>
  );
});

export const Loading: React.FC<BlockUIProps> = memo(({ blocked, fullScreen, ...props }) => {
  if (!blocked) {
    return <></>;
  }
  return (
    <BlockUI {...props} blocked={blocked} fullScreen={fullScreen} template={<LoadingTemplate />}>
      {props.children}
    </BlockUI>
  );
});

export const LoadingScreen = memo(() => {
  const isBlocked = loadingSignal.use();
  return <Loading fullScreen blocked={isBlocked > 0} />;
});
